import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { EN, fill } from '../../copy';
/**
 * Words for this panel: the language file's, else the English in copy.ts.
 *
 * @returns {Function}
 */
export default function useWords() {
    const { t } = useTranslation();
    return useCallback((key, vars) => {
        const fallback = fill(EN[key] ?? key, vars);
        try {
            const v = t(key, { ...vars,
                defaultValue: fallback });
            return typeof v === 'string' && v !== key ? v : fallback;
        }
        catch (e) {
            return fallback;
        }
    }, [t]);
}
